<script>
	export let name;
</script>

<main>
	<h1>Hi, you've reached the <b>Riggs Ward Design</b> website.</h1>
	<p>The website is currently down for maintenance. Thanks for being patient.</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: rgb(210, 93, 20);
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
